import { VulnerabilityFilterArg } from '../types/vulnerability-filter-arg'

const trackedKey = 'tracked'
const untrackedKey = 'untracked'

export function mapVulnerabilityFilters(filters: VulnerabilityFilterArg) {
  const {
    agentSessionId = [],
    tags = [],
    severities = [],
    statuses = [],
    substatus = [],
    types = [],
    environments = [],
    urls = [],
    sinks = [],
    groupedBy,
    applications = [],
    modules = [],
    servers = [],
    securityStandards = [],
    buildNumbers = [],
    routes = [],
    dateFilter,
    quickFilter,
    filterText,
    sessionMetadata,
    technologies = [],
    applicationTags = [],
    applicationMetadata,
    applicationImportances = [],
    languages = [],
    licensedOnly,
    bugtrackerStatuses = [],
    protectStatuses = []
  } = filters

  const applicationRelatedFilters =
    applications.length === 1 && modules.length > 0
      ? {
          applicationIds: modules,
          applicationID: applications[0]
        }
      : { applicationIds: applications }

  return {
    agentSessionId: agentSessionId?.[0],
    filterText,
    quickFilter,
    ...applicationRelatedFilters,
    servers,
    tags,
    severities,
    status: statuses,
    substatus,
    vulnTypes: types,
    environments,
    urls,
    sinks,
    groupedBy,
    securityStandards,
    appVersionTags: buildNumbers,
    routes,
    tracked: bugtrackerStatuses.indexOf(trackedKey) > -1,
    untracked: bugtrackerStatuses.indexOf(untrackedKey) > -1,
    timestampFilter: dateFilter && dateFilter.field,
    startDate: dateFilter && new Date(dateFilter.start).getTime(),
    endDate: dateFilter && new Date(dateFilter.end).getTime(),
    technologies,
    applicationTags,
    metadataFilters: sessionMetadata,
    applicationMetadataFilters: applicationMetadata,
    applicationImportances,
    languages,
    licensedOnly,
    protectStatuses
  }
}

function appendFilters({
  body,
  filterText,
  applicationID,
  timestampFilter,
  startDate,
  endDate,
  metadataFilters,
  licensedOnly
}) {
  if (filterText) {
    body = {
      ...body,
      filterText
    }
  }

  if (applicationID) {
    body = {
      ...body,
      applicationID
    }
  }

  if (timestampFilter) {
    body = {
      ...body,
      timestampFilter
    }
  }

  if (startDate) {
    body = {
      ...body,
      startDate
    }
  }

  if (endDate) {
    body = {
      ...body,
      endDate
    }
  }

  if (metadataFilters) {
    body = {
      ...body,
      metadataFilters
    }
  }

  if (licensedOnly) {
    body = {
      ...body,
      licensedOnly
    }
  }

  return body
}

export function appendVulnerabilityFiltersToBody(
  filters: VulnerabilityFilterArg | undefined
) {
  if (filters) {
    const {
      agentSessionId,
      filterText,
      quickFilter,
      applicationIds,
      applicationID,
      servers,
      tags,
      severities,
      status,
      substatus,
      vulnTypes,
      environments,
      urls,
      sinks,
      groupedBy,
      securityStandards,
      appVersionTags,
      routes,
      tracked,
      untracked,
      timestampFilter,
      startDate,
      endDate,
      metadataFilters,
      technologies,
      applicationTags,
      applicationMetadataFilters,
      applicationImportances,
      languages,
      licensedOnly,
      protectStatuses
    } = mapVulnerabilityFilters(filters)

    const body: any = {
      agentSessionId,
      quickFilter: quickFilter ? quickFilter : 'ALL',
      modules: applicationIds,
      servers,
      filterTags: tags,
      severities,
      status,
      substatus,
      vulnTypes,
      environments,
      urls,
      sinks,
      groupedBy,
      securityStandards,
      appVersionTags,
      routes,
      tracked,
      untracked,
      technologies,
      applicationTags,
      applicationMetadataFilters,
      applicationImportances,
      languages,
      licensedOnly,
      protectStatuses
    }

    return appendFilters({
      body,
      filterText,
      applicationID,
      timestampFilter,
      startDate,
      endDate,
      metadataFilters,
      licensedOnly
    })
  }

  return {}
}
